import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//TODO todo el personal del backoffice del monitoreo
export const getPersonaMonitoreo = async () => {
  handlerLoading({ loading: true, loadName: "personal_monitoreo" });
  try {
    const response = await axios().get("/personal_monitoreo");
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "personal_monitoreo" });
  }
};

//TODO monitoreo de interacciones por usuario
export const getMonitoreoUsuario = async (payload) => {
  handlerLoading({ loading: true, loadName: "monitoreo_usuario" });
  try {
    const response = await axios().post("/interaciones_personal_usuario", payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "monitoreo_usuario" });
  }
};

//TODO toda las interacciones de un usuario por una determinada fecha
export const getInteraccionesUnDia = async (payload) => {
  handlerLoading({ loading: true, loadName: "interacciones_de_un_dia" });
  try {
    const response = await axios().post("/interacciones_de_un_dia", payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "interacciones_de_un_dia" });
  }
};
